const svgMap = import.meta.glob('../../assets/images/**/*.svg', {
  eager: true,
  import: 'default',
  query: '?raw',
});
const assetMap = import.meta.glob(
  '../../assets/images/**/*.{png,jpg,jpeg,gif,webp}',
  {
    eager: true,
    import: 'default',
  }
);
const candidateCache = new Map();
const svgResultCache = new Map();
const assetResultCache = new Map();

function normalizeCandidates(path) {
  const original = typeof path === 'string' ? path : String(path);
  if (candidateCache.has(original)) {
    return candidateCache.get(original);
  }

  const cleaned = original
    .replace(/^\.\//, '')
    .replace(/^\.\.\//, '')
    .replace(/^images\//, '')
    .replace(/^\.\.\/images\//, '');
  const candidates = [
    original,
    `./${original}`,
    `images/${cleaned}`,
    `./images/${cleaned}`,
    `../images/${cleaned}`,
    `./../images/${cleaned}`,
    `../../assets/images/${cleaned}`,
    `./../../assets/images/${cleaned}`,
  ];
  candidateCache.set(original, candidates);
  return candidates;
}

function resolveFromMap(map, cache, path) {
  if (cache.has(path)) {
    return cache.get(path);
  }

  const candidates = normalizeCandidates(path);
  for (const candidate of candidates) {
    if (candidate in map) {
      cache.set(path, map[candidate]);
      return map[candidate];
    }
  }
  console.warn('[inlineSvg] missing asset:', path);
  cache.set(path, '');
  return '';
}

export function inlineSvg(path) {
  return resolveFromMap(svgMap, svgResultCache, path);
}

export function inlineAsset(path) {
  return resolveFromMap(assetMap, assetResultCache, path);
}
